export { default } from './Loader'
export * from './Loader'



// WEBPACK FOOTER //
// ./src/components/Loader/index.ts